<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    export default {
        data() {
            return {

            }
        },
        methods: {
			
        }
    }
</script>

<style lang="less" scoped>
</style>